/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

export const Groupbutton = styled.div`
  display: grid;
  grid-template-columns: 190px 1fr;

  .wrap-buttons{
    display: flex;
    justify-content: end;
    align-items: center;
    align-content: center;
    gap: 7px;
    margin-top: 6px;
  }
  
  button {
    padding: 0px;
    outline: none;
    margin-bottom: 0px;
  }

  button:hover {
    border-bottom: none;
  }
  
  button:disabled {
    color: #414c68;
    opacity: 0.5;
  }
`;

export const ModalContainer = styled.div`
position: relative;

.modal-int {
  position: absolute;
  background: #1F2D4D;
  width: 316px;
  min-height: 163.63px;
  padding: 2px 16px 0px 16px;
  border-radius: 5px;


  .wrap-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    border-bottom: 0.75px solid #ABABAB;

    color: #ABABAB;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 300;
    margin-top: 8px;
    padding-bottom: 8px;

    svg{
      width: 12px;
      height: 16px;
      margin-top: 6px;
    }

    .close-modal{
      cursor: pointer;
    }
    
  }

  .form-group{
    display: flex;
    flex-direction: column;
    padding: 17px 12px 0px 12px;

    .coordinatesCreated{
      display: flex;
      gap: 17px;

      .coordValue {
        background: #FFFFFF;
        width: 121.657px;
        height: 40px;
        flex-shrink: 0;
        border-radius: 3px;
        display: flex;      
        align-items: center;
        padding-left: 12px;
      }
      
      label{
        display: flex;
        justify-content: start;
        margin: 0 0 2px 0;
        
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 16px;
        color: #ABABAB;
      
      }

    }
  }
}
`;
